var Base = require('_js/base'),
  $ = require('jquery'),
  ko = require('knockout'),
  enquire = require('enquire.js');

var AUTHORIZATION_TYPE = {
  ACCOUNTANT: 1,
  AUDITOR: 2
};

function model() {
  var self = this;
  this.mobileView = ko.observable(false);
  var smallOnlyMQ = 'screen and (max-width: 40em)';
  var small = {
    match: function() {
      self.mobileView(true);
    },
    unmatch: function() {}
  };
  enquire.register(smallOnlyMQ, small);
  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  this.calculatorType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);
  this.showTypes = ko.observable(false);
  if (window.authorizationAccountant && window.authorizationAuditor) {
    this.showTypes(true);
  }
}

model.prototype.changeCalculatorType = function(type) {
  ko.postbox.publish('authorizationType', type);
};

function SimpleCalculatorViewModel() {
  this.init();
}

SimpleCalculatorViewModel.prototype = new Base();

SimpleCalculatorViewModel.prototype.init = function() {
  var $simpleCalculator = $('[data-calculator-simple]');
  if ($simpleCalculator.get(0) !== undefined) {
    ko.applyBindings(new model({}), $simpleCalculator.get(0));
  }
};

module.exports = SimpleCalculatorViewModel;
